export const ActionTypes = {
  SET_NOTIFICATION_TASKS: 'SET_NOTIFICATION_TASKS',
  SET_NOTIFICATION_TASK: 'SET_NOTIFICATION_TASK'
};
